import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapTopMenu = React.lazy(function () {
    return import('../../bootstrap-components/components/BTMenu');
});
var bootStrapTopMenu = function (props) {
    return React.createElement(BootStrapTopMenu, __assign({}, props), props.children);
};
var Menu = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapTopMenu(props);
            break;
        default:
            componentToDisplay = bootStrapTopMenu(props);
            break;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
Menu.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default React.memo(Menu);
//# sourceMappingURL=TopMenu.js.map